import { Modal } from 'react-bootstrap';

const BaseModal = ({
  show,
  handleShow,
  style,
  contentStyle,
  closeButton = true,
  size = 'xl',
  title,
  footer,
  backgroundColor,
  borderColor,
  borderWidth,
  children,
  customZIndex = 500, // Increase thise value when calling BaseModal if zIndex issues occur
  ...props
}) => {
  return (
    <Modal
      size={size}
      show={show}
      onHide={handleShow}
      style={{
        '--bs-modal-bg': backgroundColor,
        '--bs-modal-border-width': borderWidth,
        '--bs-modal-border-color': borderColor,
        zIndex: customZIndex,
        ...style,
      }}
      {...props}
    >
      {(closeButton || title) && (
        <Modal.Header closeButton={closeButton}>
          <Modal.Title className="fs-4 fw-bold w-100">{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className="d-flex flex-column" style={contentStyle}>
        {children}
      </Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default BaseModal;
